import React, { Component } from "react";
import { Box, Container, withWidth } from "@material-ui/core";
import moment from "moment-timezone";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import styles from "./style.module.scss";
import NavBar from "../../components/Navbar/Navbar";
import { connect } from "react-redux";
import { MenuSelectors } from "../../Redux/MenuRedux";
import { LoginSelectors } from "../../Redux/LoginRedux";
import { OrderSelectors } from "../../Redux/OrderRedux";
import { Grid, Divider, withStyles, withTheme, Modal } from "@material-ui/core";
import createUrlToScreen from "../../Services/Utils";
import Button from "@material-ui/core/Button";
import Api from "../../Services/Api";
import { withRouter } from "react-router-dom";
// import CreateAppointment from "../../components/CreateAppointment/CreateAppointment";
// import LoginSignup from "../../components/LoginSignup/LoginSignup";
import Loading from "../../components/Loading/Loading";
import { toast } from "react-toastify";
import "./CustomCalender.css";

const classes = (theme) => {
  return {
    orderButton: {
      backgroundColor: theme.palette.secondary.main,
      "&:hover": {
        backgroundColor: theme.palette.secondary.main,
      },
    },
  };
};

class RescheduleAppointment extends Component {
  constructor(props) {
    console.log("RescheduleAppointment props ", props);

    super(props);
    let serviceList = this.selectedService();
    const today = new Date();
    const nextDay = new Date(today);
    nextDay.setDate(today.getDate() + 1);
    const storedData = JSON.parse(localStorage.getItem("showAppointmentData"));
    const show_business_id = storedData.showAppointmentBusinessId;
    const show_appointment_id = storedData.showAppointmentId;
    const show_service_id = storedData?.showAppointmentResponse?.service_id;
    const show_staff_id = storedData?.showAppointmentResponse?.staff_id;
    const show_appointment_data = storedData?.showAppointmentResponse;
    const show_appointment_setting_data =
      storedData?.showAppointmentSettingsResponse;

    this.state = {
      serviceList: serviceList,
      date: moment(show_appointment_data?.date).format("MM-DD-YYYY") || today,
      today: today,
      availableTimeSlots: [],
      availableTimeSlotsError: "",
      selectedProductsInfo: [],
      selectedTime: null,
      showCustomerFormModal: false,
      showloginModal: false,
      rescheduleResponse: [],
      rescheduleResponseError: "",
      holidaysInfo: [],
      holidaysInfoError: "",
      rescheduleBusinessId: show_business_id,
      rescheduleappointmentId: show_appointment_id,
      rescheduleServiceId: show_service_id,
      rescheduleStaffId: show_staff_id,
      showAppointmentData: show_appointment_data,
      showAppointmentSettingData: show_appointment_setting_data,
      loading: true,
    };

    this.handleDateChange = this.handleDateChange.bind(this);
  }

  componentDidMount() {
    const selectedProductsInfo = this.props.selectedProducts.map((product) => ({
      product_id: product.product_id,
      variation_id: product.variation_id,
      staff_id: product.category_id,
    }));

    this.setState({ selectedProductsInfo }, () => {
      this.getTimeSlotApi();
    });
    this.getHolidaysApi();
  }

  // handleDateChange = (newDate) => {
  //   console.log("newDate ", newDate);
  //   this.setState({ date: newDate }, () => {
  //     this.getTimeSlotApi();
  //   });
  // };
  handleDateChange = (newDate) => {
    const selectedDate = newDate.toISOString().split("T")[0]; // format selected date to YYYY-MM-DD
    const holiday = this.state.holidaysInfo.find(
      (holiday) =>
        selectedDate >= holiday.from_day && selectedDate <= holiday.to_day
    );

    this.setState({ date: newDate }, () => {
      this.getTimeSlotApi();
    });

    if (holiday) {
      toast.success(
        `Dear Valued Customer, please be aware that we will not be operating on ${selectedDate} in celebration of ${holiday.reason}.`
      );
      return; // Prevent further actions if it's a holiday
    }
  };
  // Function to render a red dot for holiday dates
  tileContent = ({ date, view }) => {
    const selectedDate = date.toISOString().split("T")[0]; // format selected date to YYYY-MM-DD
    const holiday = this.state.holidaysInfo.find(
      (holiday) =>
        selectedDate >= holiday.from_day && selectedDate <= holiday.to_day
    );

    if (holiday) {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div
            style={{
              width: "6px",
              height: "6px",
              backgroundColor: "red",
              borderRadius: "50%",
              marginTop: "5px", // Adjust as needed for proper alignment
            }}
          />
        </div>
      );
    }

    return null; // No content for non-holiday dates
  };
  selectedService = () => {
    let result = [];
    let selectedProduct = this.props.historyJsonItem
      ? this.props.historyJsonItem.selectedProducts
      : this.props.selectedProducts;

    let selectedMenuItem = this.props.historyJsonItem
      ? this.props.historyJsonItem.menuItems
      : this.props.menuItems;
    selectedProduct.forEach((selectedProduct) => {
      let foundItem = selectedMenuItem.find(
        (menuItem) => menuItem.item_id === selectedProduct.product_id
      );
      if (foundItem) {
        result.push(foundItem.item_name);
      }
    });
    return result;
  };

  openCustomerFormModal = () => {
    if (this.props.isUserLoggedIn) {
      this.setState({
        showCustomerFormModal: true,
      });
    } else {
      this.setState({
        showloginModal: true,
        showLoadingAnimation: false,
      });
    }
  };

  closeCustomerFormModal = () => {
    this.setState({
      showCustomerFormModal: false,
    });
  };
  handleModalClose = () => {
    this.setState({ showCustomerFormModal: false });
  };
  getHolidaysApi = async () => {
    let apiService = Api.create();
    let requestObj = {
      business_id: this.state.rescheduleBusinessId,
    };
    console.log("Final requestObj 1:", requestObj);

    apiService.getHolidays(requestObj).then((response) => {
      console.log("Holidays Response ", response?.data?.data);
      if (response.status === 200) {
        this.setState({
          holidaysInfo: response?.data?.data || [],
          // loading: false,
        });
      } else {
        this.setState({
          holidaysInfoError: response?.data?.status,
          // loading: false,
        });
      }
    });
  };
  getTimeSlotApi = async () => {
    let apiService = Api.create();
    console.log(
      "this.state.selectedProductsInfo : ",
      this.state.selectedProductsInfo
    );

    // let service_ids = this.state.selectedProductsInfo.map((product) => {
    //   return product.product_id;
    // });

    // let staff_ids = this.state.selectedProductsInfo.map((product) => {
    //   return product.staff_id;
    // });
    let staff_ids = this.state.selectedProductsInfo.map(
      (product) => product.staff_id
    );

    console.log("Filtered staff_ids:", staff_ids); // Check the contents of staff_ids

    const formattedDate = moment(this.state.date).format("YYYY-MM-DD");

    if (this.props.tabValue === 1) {
      let requestObj = {
        business_id: this.state.rescheduleBusinessId,
        service_id: this.state.rescheduleServiceId,
        date: formattedDate,
        staff_id: this.state.rescheduleStaffId,
      };

      console.log("Final requestObj 1:", requestObj);

      apiService.getTimeSlots(requestObj).then((response) => {
        if (response.status === 200) {
          this.setState({
            availableTimeSlots:
              response?.data?.status_message?.appointments || [],
            loading: false,
          });
        } else {
          this.setState({
            availableTimeSlotsError: response?.data,
            loading: false,
          });
        }
      });
    } else {
      let requestObj = {
        business_id: this.state.rescheduleBusinessId,
        service_id: this.state.rescheduleServiceId,
        date: formattedDate,
      };

      apiService.getTimeSlots(requestObj).then((response) => {
        if (response.status === 200) {
          this.setState({
            availableTimeSlots:
              response?.data?.status_message?.appointments || [],
            loading: false,
          });
        } else {
          this.setState({
            availableTimeSlotsError: response?.data,
            loading: false,
          });
        }
      });
      console.log("Final requestObj 0:", requestObj);
    }
  };
  // getTimeSlotApi = async () => {
  //   let apiService = Api.create();

  //   // const currentDate = this.state.date.toISOString().split("T")[0];
  //   const formattedDate = moment(this.state.date).format("YYYY-MM-DD");
  //   var requestObj = {
  //     business_id: this.state.rescheduleBusinessId,
  //     service_id: this.state.rescheduleServiceId,
  //     date: formattedDate,
  //   };

  //   apiService.getTimeSlots(requestObj).then((response) => {
  //     if (response.status == 200) {
  //       this.setState({
  //         availableTimeSlots:
  //           response?.data?.status_message?.appointments || [],
  //         loading: false,
  //       });
  //     } else {
  //       this.setState({
  //         availableTimeSlotsError: response?.data,
  //         loading: false,
  //       });
  //     }
  //   });
  // };
  handleTimeSlotSelection = (selectedTime) => {
    this.setState({ selectedTime });
  };
  rescheduleAppointmentApi = async () => {
    let apiService = Api.create();

    // const currentDate = this.state.date.toISOString().split("T")[0];
    const formattedDate = moment(this.state.date).format("YYYY-MM-DD");

    let init_time = this.state?.showAppointmentData?.start_time;
    let formatted_time = init_time.split(" ")[1];
    let original_time = formatted_time.split(":", 2).join(":");
    var requestObj = {
      appointment_id: this.state?.showAppointmentData?.id,
      date: formattedDate,
      start_time: this.state.selectedTime
        ? this.state.selectedTime.time
        : original_time,
      service_id: this.state?.showAppointmentData?.service_id,

      staff_id: this.props.tabValue === 0 ? 0 : this.state.rescheduleStaffId,
      // staff_id: this.props.selectedOrder?.appointment_details?.staff_id
      //   ? this.props.selectedOrder?.appointment_details?.staff_id
      //   : 0,

      business_id: this.state.rescheduleBusinessId,
    };

    apiService.rescheduleAppointment(requestObj).then((response) => {
      if (response.status == 200) {
        this.setState({
          rescheduleResponse: response?.data || [],
        });
        toast.success("Appointment Reschdule Successfully Placed");
        this.props.history.push("/orderHistory");
      } else {
        this.setState({
          rescheduleResponseError: response?.data?.status_message,
        });
        toast.error(response?.data?.status_message);
      }
    });
  };
  redirectToShowAppointment = () => {
    this.props.history.push(
      createUrlToScreen(
        `showAppointment/${this.state.rescheduleBusinessId}/${this.state.rescheduleappointmentId}`,
        this.props.match.url
      )
    );
  };

  groupTimeSlots = (timeSlots) => {
    const morning = [];
    const afternoon = [];
    const evening = [];

    timeSlots.forEach((timeSlot) => {
      const [time, period] = timeSlot.human_time.split(" ");
      const [hour, minute] = time.split(":").map(Number);

      if (period === "AM") {
        morning.push(timeSlot);
      } else if (period === "PM") {
        let hourInt = hour;
        if (hourInt < 12) {
          hourInt += 12; // Convert PM hour to 24-hour format
        }

        const convertedTimeSlot = {
          ...timeSlot,
          hour_24: `${hourInt}:${minute < 10 ? "0" : ""}${minute}`,
        };

        if (hourInt < 17) {
          afternoon.push(convertedTimeSlot);
        } else {
          evening.push(convertedTimeSlot);
        }
      }
    });

    return { morning, afternoon, evening };
  };
  renderTimeSlotGroup = (group, title) => {
    const currentDate = new Date().toDateString(); // Get the current date as a string
    const selectedDateObj = new Date(this.state.date);
    const selectedDate = selectedDateObj.toDateString();
    console.log("currentDate ", currentDate);
    console.log("selectedDateObj ", selectedDateObj);
    console.log("selectedDate ", selectedDate);

    const isCurrentDate = currentDate === selectedDate;

    const currentTime = new Date();

    // Extract current time components (hours, minutes, seconds)
    const currentHours = currentTime.getHours();
    const currentMinutes = currentTime.getMinutes();
    const currentSeconds = currentTime.getSeconds();

    return (
      <div>
        <h5>{title}</h5>
        <div className={styles.gridContainer}>
          {group.length > 0 ? (
            group.map((timeSlot) => {
              // Extract hours, minutes, and seconds from timeSlot.time
              const [slotHours, slotMinutes, slotSeconds] = timeSlot.time
                .split(":")
                .map(Number);

              // Only apply the isPast logic if it's the current date
              const isPast =
                isCurrentDate &&
                (currentHours > slotHours ||
                  (currentHours === slotHours &&
                    currentMinutes > slotMinutes) ||
                  (currentHours === slotHours &&
                    currentMinutes === slotMinutes &&
                    currentSeconds > slotSeconds));

              return (
                <button
                  key={timeSlot.id}
                  className={`${styles.timeSlotButton} ${
                    this.state.selectedTime &&
                    this.state.selectedTime.human_time === timeSlot.human_time
                      ? styles.selectedTimeSlot
                      : ""
                  }`}
                  style={{
                    padding: "10px",
                    margin: "5px",
                    fontSize: "15px",
                    cursor: isPast ? "not-allowed" : "pointer", // Visual cue for disabled state
                    backgroundColor: isPast ? "#ccc" : "", // Visual cue for disabled state
                    color: isPast ? "grey" : "",
                    border: isPast ? "none" : "1px solid #007bff",
                  }}
                  onClick={() =>
                    !isPast &&
                    this.handleTimeSlotSelection({
                      time: timeSlot.time,
                      human_time: timeSlot.human_time,
                    })
                  }
                  disabled={isPast} // Disable the button if the time slot is in the past
                >
                  {timeSlot.human_time}
                </button>
              );
            })
          ) : (
            <p>No available time slots</p>
          )}
        </div>
      </div>
    );
  };
  // renderTimeSlotGroup = (group, title) => {
  //   return (
  //     <div>
  //       <h5>{title}</h5>
  //       <div className={styles.gridContainer}>
  //         {group.length > 0 ? (
  //           group.map((timeSlot) => (
  //             <button
  //               key={timeSlot.id}
  //               className={`${styles.timeSlotButton} ${
  //                 this.state.selectedTime &&
  //                 this.state.selectedTime.human_time === timeSlot.human_time
  //                   ? styles.selectedTimeSlot
  //                   : ""
  //               } `}
  //               style={{
  //                 padding: "10px",
  //                 margin: "5px",
  //                 fontSize: "15px",
  //               }}
  //               onClick={() =>
  //                 this.handleTimeSlotSelection({
  //                   time: timeSlot.time,
  //                   human_time: timeSlot.human_time,
  //                 })
  //               }
  //             >
  //               {timeSlot.human_time}
  //             </button>
  //           ))
  //         ) : (
  //           <p>No available time slots</p>
  //         )}
  //       </div>
  //     </div>
  //   );
  // };
  formatDate(dateString) {
    const monthMap = {
      Jan: "01",
      Feb: "02",
      Mar: "03",
      Apr: "04",
      May: "05",
      Jun: "06",
      Jul: "07",
      Aug: "08",
      Sep: "09",
      Oct: "10",
      Nov: "11",
      Dec: "12",
    };

    const dateParts = dateString.split(" ");
    const day = dateParts[2];
    const month = monthMap[dateParts[1]];
    const year = dateParts[3];

    return `${day}/${month}/${year}`;
  }

  addDays = (date, days) => {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  };
  render() {
    console.log("this.state.today ", this.state.today);
    console.log("this.state.date ", this.state.date);
    const { width } = this.props;
    const isMobile = /xs|sm/.test(width);
    const { date, availableTimeSlots, selectedTime } = this.state;
    console.log("selectedTime ", selectedTime);
    // const formattedDate = this.formatDate(date.toDateString());
    const formattedDate = moment(date).format("MMM D, YYYY");
    const bookeddDate = moment(this.state.showAppointmentData?.date).format("MMM D, YYYY");
    console.log("formattedDate ", formattedDate);
    const { morning, afternoon, evening } =
      this.groupTimeSlots(availableTimeSlots);
    console.log(
      "this.state.selectedProductsInfo",
      this.state.selectedProductsInfo
    );
    // let init_time = this.props.selectedOrder?.appointment_details?.start_time;
    // let formatted_time = init_time.split(" ")[1];
    // let original_time = formatted_time.split(":", 2).join(":");
    const noOfDaysInCalander = parseInt(
      this.state.showAppointmentSettingData?.no_days_shown_calendar,
      10
    );
    const selectedDateObj = new Date(this.state.date);
    const selectedDate = selectedDateObj.toISOString().split("T")[0];
    // Check if the selected date is a holiday
    const holiday = this.state.holidaysInfo.find(
      (holiday) =>
        selectedDate >= holiday.from_day && selectedDate <= holiday.to_day
    );
    console.log("holiday ", holiday);
    return (
      <>
        <Box style={{ minHeight: "94vh" }}>
          <NavBar />
          <Container style={{ paddingTop: "20px" }}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={3}>
                <div style={{ marginTop: "20px" }}>
                  <div
                    style={{
                      fontSize: "17px",
                      fontWeight: "bold",
                      marginBottom: "12px",
                    }}
                  >
                    Appointment Summary
                  </div>
                  <Divider />

                  <div style={{ marginTop: "13px" }}>
                    Service : {this.state?.showAppointmentData?.service_name}
                  </div>

                  <Divider />
                  <div
                    style={{
                      fontSize: "16px",
                      fontWeight: "500",
                      marginBottom: "12px",
                      marginTop: "13px",
                    }}
                  >
                    Booked Summary
                  </div>

                  <div style={{ marginTop: "13px" }}>Date :{bookeddDate}</div>
                  <div style={{ marginTop: "13px" }}>
                    Time :{this.state?.showAppointmentData?.human_start_time}
                  </div>
                  <Divider />
                  <div
                    style={{
                      fontSize: "16px",
                      fontWeight: "500",
                      marginBottom: "12px",
                      marginTop: "13px",
                    }}
                  >
                    Reschedule Summary
                  </div>

                  <div style={{ marginTop: "13px" }}>Date :{formattedDate}</div>
                  <div style={{ marginTop: "13px" }}>
                    Time : {selectedTime ? selectedTime.human_time : ""}
                  </div>
                </div>
              </Grid>

              <Divider orientation="vertical" flexItem />

              <Grid item xs={12} sm={8}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <div>
                      <Calendar
                        onChange={this.handleDateChange}
                        value={this.state.date}
                        minDate={this.state.today}
                        maxDate={
                          noOfDaysInCalander === 0
                            ? this.state.today
                            : this.addDays(
                                this.state.today,
                                noOfDaysInCalander - 1
                              )
                        }
                        tileContent={this.tileContent} // Add tileContent prop here
                      />
                    </div>
                  </Grid>
                  {/* <Grid item xs={12} md={6}>
                    <div>
                      <Calendar
                        onChange={this.handleDateChange}
                        value={this.state.date}
                        minDate={this.state.today}
                        maxDate={
                          noOfDaysInCalander === 0
                            ? this.state.today
                            : this.addDays(
                                this.state.today,
                                noOfDaysInCalander - 1
                              )
                        }
                      />
                    </div>
                  </Grid> */}
                  <Grid item xs={12} md={6}>
                    {this.state.loading && (
                      <Box>
                        <Grid
                          container
                          justify="space-around"
                          // style={{ height: "calc(100vh - 40px)" }}
                          alignItems="center"
                          alignContent="center"
                        >
                          <Grid
                            item
                            xs={12}
                            sm={12}
                            style={{ maxHeight: "20vh", maxWidth: "20vh" }}
                          >
                            <Loading title="Loading Timeslots Please Wait!!!" />
                          </Grid>
                        </Grid>
                      </Box>
                    )}
                    {!this.state.loading && holiday ? (
                      <div>
                        <h3>Holiday Notice</h3>
                        <hr></hr>
                        <p style={{ letterSpacing: "1px", padding: "10px" }}>
                          {" "}
                          "Hello! We wanted to inform you that our services will
                          be unavailable on{" "}
                          <span style={{ fontWeight: "bold", color: "red" }}>
                            {holiday.date}
                          </span>{" "}
                          due to{" "}
                          <span style={{ fontWeight: "bold", color: "red" }}>
                            {holiday.reason}
                          </span>
                          ."
                        </p>
                      </div>
                    ) : (
                      <>
                        {this.renderTimeSlotGroup(morning, "MORNING")}
                        {this.renderTimeSlotGroup(afternoon, "AFTERNOON")}
                        {this.renderTimeSlotGroup(evening, "EVENING")}
                      </>
                    )}
                    {/* {!this.state.loading && (
                      <div>
                        {this.renderTimeSlotGroup(morning, "MORNING")}
                        {this.renderTimeSlotGroup(afternoon, "AFTERNOON")}
                        {this.renderTimeSlotGroup(evening, "EVENING")}
                      </div>
                    )} */}
                  </Grid>
                  <Grid item xs={12}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: isMobile ? "column" : "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <div>
                        <Button
                          variant="contained"
                          color="secondary"
                          onClick={this.redirectToShowAppointment}
                          // disabled={!selectedTime}
                          style={{
                            width: "200px",
                            height: "40px",
                            paddingRight: "20px",
                            paddingLeft: "20px",
                            marginBottom: "20px",
                          }}
                        >
                          Show Appointment
                        </Button>
                      </div>
                      <div>
                        <Button
                          variant="contained"
                          color="secondary"
                          onClick={this.rescheduleAppointmentApi}
                          disabled={!selectedTime}
                          style={{
                            width: "150px",
                            height: "40px",
                            paddingRight: "10px",
                            paddingLeft: "10px",
                            marginBottom: "20px",
                          }}
                        >
                          Confirm
                        </Button>
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Container>
        </Box>
        {/* <Modal
          open={this.state.showCustomerFormModal}
          onClose={this.closeCustomerFormModal}
        >
          <div className={styles.customerModalStyle} id="modifiers">
            <CreateAppointment
              isUserLoggedIn={this.props.isUserLoggedIn}
              business_id={this.props.businessId}
              location_id={this.props.locationId}
              selectedProductsInfo={this.state.selectedProductsInfo}
              selected_date={formattedDate}
              selectedTime={selectedTime ? selectedTime.time : ""}
              onClose={this.handleModalClose}
            />
          </div>
        </Modal>

        <Modal open={this.state.showloginModal} disableBackdropClick>
          <div className={styles.loginModalStyle}>
            <LoginSignup
              nextScreen="customerForm"
              onClose={() => this.setState({ showloginModal: false })}
            />
          </div>
        </Modal> */}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    selectedProducts: OrderSelectors.getProducts(state),
    menuItems: MenuSelectors.getMenuItems(state),
    businessInfo: MenuSelectors.getBusinessInfo(state),
    businessId: state.menu.business_id,
    locationId: state.menu.location_id,
    orderType: LoginSelectors.getOrderTypeId(state),
    userInfo: LoginSelectors.getUserInfo(state),
    variationList: MenuSelectors.getVariationList(state),
    token: LoginSelectors.getUserToken(state),
    restaurantTimeZone: MenuSelectors.getTimezone(state),
    restaurantName: MenuSelectors.getRestaurantName(state),
    isUserLoggedIn: LoginSelectors.isUserloggedIn(state),
    restaurantInfo: OrderSelectors.getRestaurantInfo(state),
    orderStatus: state.order.orderStatus,
    selectedOrder: state.order.selectedOrder,
    tabValue: state.menu.tabValue,
  };
};

export default withRouter(
  connect(mapStateToProps)(
    withTheme(
      withTheme(withStyles(classes)(withWidth()(RescheduleAppointment)))
    )
  )
);
